// extracted by mini-css-extract-plugin
export default {"card":"menu_card__IR-0E"};